<script>
export default {
    name: 'IconClock',
}
</script>
<template>
    <svg class="base-icon icon-clock" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64"><g clip-path="url(#a)"><path fill="currentColor"  fill-rule="evenodd" d="M32 64C14.326 64 0 49.674 0 32S14.326 0 32 0s32 14.326 32 32-14.326 32-32 32Zm0-6.4a25.6 25.6 0 1 0 0-51.2 25.6 25.6 0 0 0 0 51.2ZM35.2 32H48v6.4H28.8V16h6.4v16Z" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h64v64H0z"/></clipPath></defs></svg>
</template>
